import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'MA' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'MA', label: 'Moving Average', pane: 'main', params: [5, 10, 30, 60], outputs: ['ma5', 'ma10', 'ma30', 'ma60'], labels: ['Period 1', 'Period 2', 'Period 3', 'Period 4'] })
